/**
 * URL paths that the application can handle via deep links.
 * These paths are used in incoming deep links and will be mapped to a DeepLink object for further processing.
 */
export enum DeepLinkPath {
    HOME = '/home',
    ORDERS = '/order-list',
    COUPONS = '/coupons',
    LISTS = '/lists',
    USUAL_PURCHASE = '/usual-purchase',
    FAVORITES = '/favorites',
    PROMOTIONS = '/catalog/Z',
    NEWS = '/catalog/N',
    BEST_SELLERS = '/catalog/T',
    CATEGORIES = '/catalog/categories',
    CATALOG = '/catalog',
    COMPARATOR = '/comparison',
    CHANGE_EMAIL = '/account-config/change-email',
    CHANGE_PASSWORD = '/account-config/change-password',
    CHECKOUT = '/checkout',
    ACCOUNT = '/account',
    PRODUCT_DETAIL = '/product-detail',
    PROMOTION_DETAIL = '/promotion-detail',
    LOGIN = '/login',
    SHARED = '/shared',
}
